import script from "./print.vue?vue&type=script&setup=true&lang=js"
export * from "./print.vue?vue&type=script&setup=true&lang=js"

import "./print.vue?vue&type=style&index=0&id=822080a0&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-822080a0"]])

export default __exports__